export default {
    'langs':'语言',
    'zh':'中文',
    'test':'测试',
    'yhdl':'用户登录',
    'tcdl':'退出登录',
    'xtgl':'系统管理',
    'kczx':"课程中心",
    'jssbgl':'一站式人工智能教学平台',
    'jtpt':'设备管理',
    'yhm':'用户名',
    'gh':'工号',
}